export default "__VITE_ASSET__1ea405fc__"